import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './Chatbot.css';
import chatbotFlow from './chatbotFlow.json';
import LogoGeo from '../../../assets/img/LogoGeo.png';
import ChatbotIcon from '../../../assets/img/ChatbotIcon.png';

const Chatbot = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentNode, setCurrentNode] = useState('start');
    const [history, setHistory] = useState([]);
    const location = useLocation();
    const bodyRef = useRef(null);

    // Visibility logic: only show on specific public paths
    const allowedPaths = [
        '/',
        '/quienes-somos',
        '/indicadores',
        '/mapa',
        '/consultar',
        '/ambiental'
    ];

    const isVisible = allowedPaths.includes(location.pathname) || location.pathname === '';

    useEffect(() => {
        if (bodyRef.current) {
            bodyRef.current.scrollTop = 0;
        }
    }, [currentNode, isOpen]);

    if (!isVisible) return null;

    const toggleChat = () => setIsOpen(!isOpen);

    const handleOptionClick = (next) => {
        if (next === 'start') {
            setHistory([]);
            setCurrentNode('start');
        } else {
            setHistory([...history, currentNode]);
            setCurrentNode(next);
        }
    };

    const node = chatbotFlow[currentNode] || chatbotFlow['start'];

    return (
        <div className="chatbot-wrapper">
            {/* Floating Action Button */}
            <div className="chatbot-fab" onClick={toggleChat} title="Asistente GeoHCX">
                {isOpen ? (
                    <i className="bi bi-x-lg"></i>
                ) : (
                    <img src={ChatbotIcon} alt="Chatbot" className="chatbot-fab-img" />
                )}
            </div>

            {/* Chat Window */}
            {isOpen && (
                <div className="chatbot-container">
                    <div className="chatbot-header">
                        <div className="chatbot-header-info">
                            <div className="chatbot-header-logo">
                                <img src={ChatbotIcon} alt="GeoHCX" style={{ width: '100%', height: 'auto', borderRadius: '50%' }} />
                            </div>
                            <div className="chatbot-header-text">
                                <h3>Asistente GeoHCX</h3>
                                <span>En línea • Educativo</span>
                            </div>
                        </div>
                        <button className="chatbot-close-btn" onClick={toggleChat}>
                            <i className="bi bi-dash"></i>
                        </button>
                    </div>

                    <div className="chatbot-body" ref={bodyRef}>
                        <div className="chatbot-message">
                            {node.message}

                            {node.disclaimer && (
                                <div className="chatbot-disclaimer">
                                    <i className="bi bi-exclamation-circle-fill"></i>
                                    <p>
                                        Esta información es educativa y no reemplaza la atención médica.
                                        Para diagnóstico o tratamiento, consulte a un profesional de la salud.
                                    </p>
                                </div>
                            )}
                        </div>

                        <div className="chatbot-options">
                            {node.options.map((option, index) => (
                                <button
                                    key={index}
                                    className="chatbot-option-btn"
                                    onClick={() => handleOptionClick(option.next)}
                                >
                                    {option.text}
                                    <i className="bi bi-chevron-right"></i>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="chatbot-footer">
                        <span>Poder Institucional • GeoHCX</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Chatbot;
